module.exports = __webpack_public_path__ + "img/ero_eraworldcoin.61fa03e.png";